import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBzwrZb22Mw-j9Sb_mmkH1jnrnsezVzuXU",
  authDomain: "pk-real-estate-f4393.firebaseapp.com",
  projectId: "pk-real-estate-f4393",
  storageBucket: "pk-real-estate-f4393.appspot.com",
  messagingSenderId: "177710335503",
  appId: "1:177710335503:web:5fdac50c7421520b3d457a",
  measurementId: "G-8ZVF26RZZV"
};


export const app = initializeApp(firebaseConfig);